<!--
 * @FileDescription: 部门管理（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container department">
      <div class="page-container-height">
          <div style="display: flex;align-items: center;margin-bottom: 20px">
              <div class="department-add" @click="onEdit(1)" v-has="'system_staff_add'">
                  <img src="@/assets/image/depart_add@2x.png"/>
                  <span>新增员工</span>
              </div>
              <div class="department-right-top">
                  <div class="department-top-left">
                      <a-input placeholder="请输入关键字查询" v-model="inputvalue" @pressEnter="onSearch(1)" class="department-input"></a-input>
                      <a-button class="button-search" @click="onSearch(1)">搜索</a-button>
                      <a-button class="button-search1" @click="onSearch(2)">重置</a-button>
                  </div>
              </div>
          </div>
          <div class="department">
              <div class="department-left">
                  <treeLeft ref="treeLeft" :treeList="treeList" :index="1" :tab="1" @saveDepart="saveDepart" @onSelectKey="onSelectKey" @onSelectAll="onSelectAll"></treeLeft>
              </div>
              <div class="department-right">
                  <a-table :columns="columns"
                           :dataSource="dataSource"
                           :pagination="pagination"
                           bordered
                           @change="handleTableChange"
                           class="table-height"
                           :scroll="{ y: 'calc(100vh - 400px)' }"
                           rowKey="key">
                      <template slot="state" slot-scope="text, record">
                             <span :class="record.state ==1 ? 'audit-state' : 'audit-state audit-state1'">
                                  <span class="audit-state-cir" ></span>
                                  <span v-if="text == 1">在职</span>
                                   <span v-else>离职</span>
                              </span>
                      </template>
                      <template slot="operation" slot-scope="text, record">
                          <div class="operation">
                              <div class="operation-left" @click="onEdit(2,record)" v-has="'system_staff_edit'">编辑</div>
                              <div class="operation-right">
                                  <div class="operation-item" @click="onDelete(record.id)" v-has="'system_staff_delete'">
                                      <a href="javascript:;" >
                                          <img src="@/assets/image/cha_shanchu_color.png" class="operation-item-img" />
                                          <img src="@/assets/image/cha_shanchu.png" class="operation-item-img1"/>
                                      </a>
                                  </div>
                              </div>
                          </div>
                      </template>
                  </a-table>
              </div>
          </div>

      </div>
      <v-departModel ref="departModel"
                     :companyList="treeList"
                     @saveStaff="saveStaff"
      >

      </v-departModel>
      <deleteModal ref="deleteModal" @confirmDeletion="confirmDeletion"></deleteModal>
  </div>
</template>
<script>
import picture from "@/components/upload/picture.vue"
import {getfindDepart,updateDepart,deleteStaff} from "@/utils/api";
import departModel from './model/departModel'
import treeLeft from '../set/model/TreeLeft'
import deleteModal from '@/components/module/deleteModal'
import {mixins} from "@/mixins/mixins";
export default {
  mixins:[mixins],
  data () {
    return {
        inputvalue:'',
        treeList:[ ],
        columns: [
            {
                title: '',
                dataIndex: '',
                key: 'rowIndex',
                width: 45,
                align: "center",
                customRender: function (t, r, index) {
                    return parseInt(index) + 1;
                }
            },
            {
                title: '员工姓名',
                key: 'name',
                dataIndex: 'name',
                ellipsis: true,
            },
            {
                title: '手机号',
                dataIndex: 'mobile',
                align: 'center',
                key: 'mobile',
                ellipsis: true,
            },
            {
                title: '员工工号',
                key: 'code',
                dataIndex: 'code',
                ellipsis: true,
            },
            {
                title: '部门',
                key: 'departName',
                dataIndex: 'departName',
                ellipsis: true,
            },
            {
                title: '入职时间',
                key: 'entryDate',
                dataIndex:'entryDate',
                ellipsis: true,
            },
            {
                title: '在职状态',
                key: 'state',
                dataIndex:'state',
                ellipsis: true,
                scopedSlots: { customRender: 'state' },
            },
            {
                title: '操作',
                fixed: 'right',
                width:80,
                scopedSlots: { customRender: 'operation' },
            },
        ],
        dataSource: [],
        departId:'',
    }
  },
  components: {
      'v-picture':picture,
      'v-departModel':departModel,
      treeLeft,
      deleteModal
  },
  watch: {
      pageList: {
          handler(newValue, oldValue) {
              if(!this.isEmpty(newValue.result)){
                  this.dataSource = newValue.result.records
                  this.pagination.current = newValue.result.current
                  this.pagination.total =newValue.result.total
                  this.pagination.pageSize = newValue.result.size
                  this.pages = this.pageList.result.pages
                  this.$store.state.isLoding = false

              }
          },
          deep: true
      },
  },
  mounted () {
    this.getDepartMessage()
    this.getfindStaffAllMessage()
  },
  created () {

  },
  methods: {
      /**
       * @description: 获取全部部门信息（方法描述）
       */
      getDepartMessage(){
          let data = {
              companyStoreId:this.$store.state.shopId,
          }
          data =   this.$qs.stringify(data)
          getfindDepart(data,{
              'Content-Type':'application/x-www-form-urlencoded'
          }).then((res)=>{
                res.result.forEach((item)=>{
                    item.isCheck = false
                    item.isActive = false
                    item.name1 = item.name
                })
                this.treeList = res.result
          })
      },

      /**
       * @description: 获取全部员工信息（方法描述）
       */
      getfindStaffAllMessage(){
          this.$store.state.isLoding = true
          this.getPageList('/system/api/pageStaffByConditions',
                  {   companyStoreId:this.$store.state.shopId,
                      pageNo:this.pagination.current,
                      pageSize:this.pagination.pageSize,
                      departId:this.departId,
                      search:this.inputvalue,
                  },{
                      'Content-Type':'application/json'
                  })
      },
      /**
       * @description: 搜索（方法描述）
       */
      onSearch(index){
          if(index == 1){
              this.pagination.current = 1
              this.getfindStaffAllMessage()
          }else{
              this.pagination.current = 1
              this.inputvalue = ''
              this.getfindStaffAllMessage()
          }
      },
      /**
       * @description: 删除（方法描述）
       */
      onDelete(id){
          let item = {}
          item.content = '您确定要删除员工吗'
          item.id = id
          this.$refs.deleteModal.show(item)
      },
      confirmDeletion(item){
          let data = {
              id:item.id,
              companyStoreId:this.$store.state.shopId,
          }
          data =   this.$qs.stringify(data)
          deleteStaff(data,{}).then((res)=>{
              if(res.success){
                  this.getfindStaffAllMessage()
                  this.$message.success(res.logMessage)
              }else{
                  this.$message.warn(res.logMessage)
              }
          })
      },
      /**
       * @description: 表格页数切换（方法描述）
       */
      handleTableChange(pagination, filters, sorter){
          this.pagination.current = pagination.current
          this.pagination.pageSize = pagination.pageSize
          this.size = pagination.pageSize
          this.getfindStaffAllMessage()
      },
      /**
       * @description: 新增和编辑员工信息（方法描述）
       */
      onEdit(index,record){
          if(index== 1){
              this.$refs.departModel.onOpen1({},1)
          }else{
              this.$refs.departModel.onOpen1(record,2)
          }
      },
      /**
       * @description: 部门添加或修改成功（方法描述）
       */
      saveDepart(){
          this.getDepartMessage()
      },
      saveStaff(){
          this.getfindStaffAllMessage()
      },
      /**
       * @description: 选择部门回调（方法描述）
       */
      onSelectKey(value){
          this.departId = value
          this.getfindStaffAllMessage()
      },
      onSelectAll(){
          this.departId = ''
          this.getfindStaffAllMessage()

      },
  },
}
</script>
<style lang="scss">
    .page-container-height{
        width: 100%;
    }
    .department{
        .ant-table-wrapper{
            padding: 0;
        }
        .ant-tree li{
            line-height: 36px;
            padding: 0 !important;
        }
        .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before, .ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper::before{
            height: 36px !important;
        }
        .ant-tree li span.ant-tree-switcher, .ant-tree li span.ant-tree-iconEle{
            line-height: 30px !important;
        }
        .ant-tree li .ant-tree-node-content-wrapper{
            line-height: 36px !important;
            flex: 1;
            height: 36px;
            width: 88%;
        }
        .ant-tree-title{
            width: 75%;
            display: inline-block;
        }
        .tree-span{
            width: 100%;
            display: inline-block;
        }
        .form-left{
            flex: 1;
            padding-left: 40px;
            .ant-input{
                width: 200px;
            }
            .ant-col-12{
                padding-left: 20px;
                width: 55%;
            }
        }
        .model-form{
            .model-footer{
                padding-left: 18% !important;
            }
        }
        .down-up{
            width:120px;
            height:40px;
            border:1px solid #DDDDDD;
            border-radius:2px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .down-up-icon{
                color: #AAAAAA;
                padding-right: 5px;
            }
            .input-file{
                position: absolute;
                top: 0;
                left: 0;
                width: 120px;
                height: 40px;
                display: inline-block;
                opacity: 0;
            }
        }
        .ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before{
            background: rgba(247,111,20,0.1)!important;
        }
        .ant-tree-node-content-wrapper.ant-tree-node-selected{
            color: #333333!important;
        }
        .tree-input{
            .ant-input{
                height: 28px !important;
                line-height:28px !important;
            }
        }
        .table-height{
            .ant-table{
                height: calc(100vh - 300px);
            }
        }
    }
</style>
<style lang="scss" scoped>
  .page-container{
      background: #FFFFFF;
      padding: 0;
  }
  .page-container-height{
      padding: 20px 18px 0 29px;
      .department-right-top{
          width: 200px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .department-top-left{
              display: flex;
              align-items: center;
              .department-input{
                  width: 260px;
                  margin-right: 16px;
              }
          }
      }
      .department{
          display: flex;
      }
      .department-left{
          flex: 0 0 190px;
          border: 1px solid #EEEEEE;
          padding-top: 20px;
          padding-left: 10px;
          height: calc(100vh - 300px);
          .department-left-top{
              padding-left: 3px;
              padding-bottom: 10px;
              img{
                  width: 16px;
                  margin-left: 5px;
              }
          }
      }
      .department-right{
          flex: 1;
          margin-left: 8px;
          overflow: hidden;
          .operation{
              display: flex;
              .operation-left{
                  color: #387BFC;
                  margin-right: 10px;
                  cursor: pointer;
              }
              .operation-right{
                  cursor: pointer;
              }
          }
      }
  }
  .upload-img{
      display: flex;
      align-items: center;
      justify-content: center;
      .upload-img-left{
          position: relative;
          img{
              width: 100px;
              height: 100px;
          }
          .upload-delete{
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100px;
              height: 24px;
              background:rgba(0,0,0,0.3);
              display: flex;
              justify-content: flex-end;
              align-items: center;
              .upload-delete-icon{
                  color: #FFFFFF;
                  font-size: 16px;
                  padding-right: 6px;
              }
          }
      }
      .upload-more{
          color: #387BFC;
          font-size: 14px;
          position: relative;
          padding-left: 10px;
          .input-file{
              display: inline-block;
              position: absolute;
              top: 0;
              left: 0;
              opacity: 0;
              width: 56px;
              height: 40px;
          }
      }
  }
  .tree-span{
      img{
          width: 11px;
          height: 12px;
          margin-left: 8px;
      }
      .tree-input{
          width: 100px;
          height: 28px !important;
          line-height: 28px !important;
      }
  }
</style>
